import { badgeTemplateClassifierEntityName, } from '../../../../backend/config/classifiers/badge-template-classifier/types';
import { BadgePreviewContextProvider } from '../../../../ui/features/badge-preview/contexts/BadgePreviewContext';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.title;
}
const EntityDetailsComponent = (props) => {
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Title', value: capitalize(props.response.data.title) },
            { label: 'Order', value: props.response.data.order },
        ] }));
};
function getBadgeTemplateClassifierFormConfig() {
    return {
        key: '!form',
        type: 'form',
        children: [
            {
                type: 'badges.customLayout',
                children: [
                    {
                        type: 'form.panel',
                        children: [
                            {
                                type: 'form.text',
                                key: 'name',
                                label: 'Name',
                                validate: {
                                    required: true,
                                },
                            },
                            {
                                type: 'form.text',
                                key: 'title',
                                label: 'Title',
                                validate: {
                                    required: true,
                                },
                            },
                            {
                                type: 'form.select',
                                key: 'status',
                                label: 'Status',
                                validate: {
                                    required: true,
                                },
                                values: [
                                    {
                                        value: 'active',
                                        label: 'Active',
                                    },
                                    {
                                        value: 'deprecated',
                                        label: 'Deprecated',
                                    },
                                    {
                                        value: 'retired',
                                        label: 'Retired',
                                    },
                                ],
                            },
                            {
                                type: 'form.number',
                                key: 'order',
                                label: 'Order',
                                validate: {
                                    required: true,
                                },
                            },
                            {
                                type: 'form.text',
                                multiline: true,
                                rows: 15,
                                key: 'badgeTemplateFront',
                                label: 'Front Template',
                                validate: {
                                    required: true,
                                },
                                defaultValue: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394 624">
    <rect x="0.5" y="0.5" width="393" height="623" fill="white" />
    <text x="140" y="100" font-family="sans-serif" font-size="20">Sample Text</text>                                
</svg>
`,
                            },
                            {
                                type: 'form.text',
                                multiline: true,
                                rows: 15,
                                key: 'badgeTemplateBack',
                                label: 'Back Template',
                                validate: {
                                    required: true,
                                },
                                defaultValue: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394 624">
    <rect x="0.5" y="0.5" width="393" height="623" fill="white" />
    <text x="140" y="100" font-family="sans-serif" font-size="20">Sample Text</text>                                
</svg>
`,
                            },
                        ],
                    },
                    {
                        type: 'badges.templatePreview',
                    },
                ],
                rootSx: {
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    p: 2,
                    gap: { xs: 2, lg: 4 },
                },
                childrenSx: [
                    {
                        flexBasis: '50%',
                    },
                    {
                        flexBasis: '50%',
                    },
                ],
            },
        ],
    };
}
const BadgeTemplateAdminPage = () => {
    const { t } = useBadgingTranslation();
    return (React.createElement(ClassifierAdminPage, { entity: badgeTemplateClassifierEntityName, title: 'Badge Templates', tableColumns: [
            {
                headerLabel: t('classifiers.badgeTemplateAdminPage.table.columnTitle'),
                sortKey: 'title',
                cellFunction: (row) => React.createElement(TextCell, null, getEntityTitle(row)),
            },
            {
                headerLabel: t('classifiers.badgeTemplateAdminPage.table.columnOrder'),
                sortKey: 'order',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.order),
            },
            {
                headerLabel: t('classifiers.badgeTemplateAdminPage.table.columnStatus'),
                sortKey: 'status',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.status),
            },
        ], getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, defaultSortColumnKey: 'order', formConfig: getBadgeTemplateClassifierFormConfig(), entityDetailsEditForm: true, entityDetailsPreviewForm: true, formWidth: 1200, fullTextSearchField: 'title' }));
};
/**
 * Initialize Badging Classifier Pages
 *
 * @param props.onGetTemplateDataForBadgeClassifierImageGeneration - create final data for template compilation, e.g. load app specific account info, advanced formatting...
 */
export function initBadgeTemplateAdminPageComponent(props) {
    // cannot use directly, needs to be wrapped in context
    return () => (React.createElement(BadgePreviewContextProvider, { onGetTemplateDataForBadgeClassifierImageGeneration: props.onGetTemplateDataForBadgeClassifierImageGeneration, defaultSampleAccountData: props.defaultSampleAccountData, defaultFormSettings: props.defaultFormSettings },
        React.createElement(BadgeTemplateAdminPage, null)));
}
